import { Components } from "@thisgorilla/primate-ds";
import { Formik, FormikValues } from "formik";
import { useMemo, useState } from "react";
import { useTheme } from "styled-components";
import { API_CALLS } from "../../../../../API/api_calls";
import { Divider, LabelContainer } from "../../../../../commonStyles";
import { isFormSubmitButtonDisabled } from "../../../../../utils";
import { PollChoices } from "../../../../Common";
import { FlexRowEnd } from "../../../../Common/Styles";
import Input from "../../../../Input";
import { PollProps } from "./Poll";
import { ChoicesAndDurationContainer, PollContainer } from "./style";
import { useFindContent } from "../../useFindContent";
import { ArticleProps } from "../../../../../redux/slices/article/Article";

const CreatePoll = ({
  id,
  setIsPollCreated,
  pollOptions,
}: PollProps.CreatePollProps) => {
  const { typography } = useTheme();
  const [choiceCount, setChoiceCount] = useState(
    Array.from(
      { length: pollOptions.length > 3 ? pollOptions.length : 3 },
      (_, i) => i + 1
    )
  );
  const {
    article_order,
    content_id,
    content_type,
    post_id,
    row_config,
    content_data,
  } = useFindContent(id) as ArticleProps.WithPollContent;
  const {
    question,
    choice_1,
    choice_2,
    choice_3,
    choice_4,
    choice_5,
    choice_6,
    choice_7,
    choice_8,
    choice_9,
    choice_10,
  } = content_data;

  const requiredFileds = useMemo(() => {
    const required: { [key: string]: boolean } = {};
    required["question"] = true;
    for (let i = 1; i <= choiceCount.length; i++) {
      required[`choice_${choiceCount[i - 1]}`] = true;
    }

    return required;
  }, [choiceCount]);

  return (
    <Formik
      initialValues={{
        question,
        choice_1,
        choice_2,
        choice_3,
        choice_4,
        choice_5,
        choice_6,
        choice_7,
        choice_8,
        choice_9,
        choice_10,
      }}
      onSubmit={() => {}}
      enableReinitialize
    >
      {(formik) => {
        return (
          <PollContainer id="create-poll">
            <FlexRowEnd>
              <Components.IconButton
                disabled={false}
                iconType="X"
                kind="Secondary"
                size="Small"
                onClick={() =>
                  API_CALLS.ARTICLE.deleteASingleArticleContent(id)
                }
              />
            </FlexRowEnd>
            <Divider />
            <LabelContainer>
              <Components.Text
                style={{ tokenStyle: typography.Heading.XXS }}
                text="Question"
                fontWeight="font-weight-semibold"
                lineHeight="line-height-50"
              />
            </LabelContainer>
            <Input
              fieldName="question"
              idPrefix="create-poll"
              isRequired
              placeholder="Add your question"
              size="Medium"
            />
            <Divider />
            <ChoicesAndDurationContainer $column={choiceCount.length > 5}>
              <PollChoices
                choiceCount={choiceCount}
                setChoiceCount={setChoiceCount}
                formik={formik}
              />
            </ChoicesAndDurationContainer>
            <Divider />
            <FlexRowEnd>
              <Components.Button
                color="Primary"
                kind="Primary"
                disabled={isFormSubmitButtonDisabled({
                  formik,
                  requiredFileds,
                })}
                label="Save"
                onClick={() => {
                  const newValues: FormikValues = { ...formik.values };
                  const newChoice: FormikValues = {};
                  delete newValues.question;

                  Object.values(newValues).forEach((choice, index) => {
                    newChoice[`choice_${index + 1}`] = choice;
                  });

                  API_CALLS.ARTICLE.createOrUpdateArticleContent({
                    article_order,
                    content_id,
                    content_type,
                    post_id,
                    element_role: row_config.element_role,
                    content_data: JSON.stringify({
                      ...newChoice,
                      question: formik.values.question,
                    }),
                  }).then(() => {
                    setIsPollCreated(true);
                  });
                }}
                size="Medium"
              />
            </FlexRowEnd>
          </PollContainer>
        );
      }}
    </Formik>
  );
};

export default CreatePoll;
